export function RisographBackground() {
	return (
		<div className="fixed inset-0 -z-10 overflow-hidden bg-cream">
			{/* Grain filter */}
			<svg className="absolute inset-0 w-0 h-0" aria-hidden="true">
				<title>Decorative grain filter</title>
				<defs>
					<filter id="grain">
						<feTurbulence
							type="fractalNoise"
							baseFrequency="0.65"
							numOctaves="3"
							stitchTiles="stitch"
						/>
						<feColorMatrix type="saturate" values="0" />
						<feBlend in="SourceGraphic" mode="multiply" />
					</filter>
				</defs>
			</svg>
			{/* Grain overlay */}
			<div
				className="absolute inset-0 opacity-[0.08] pointer-events-none"
				style={{ filter: "url(#grain)" }}
			/>
			{/* Risograph blobs */}
			<div
				className="absolute -top-32 -left-32 w-[600px] h-[600px] rounded-full opacity-30 pointer-events-none"
				style={{
					background: "radial-gradient(circle, #4A7DE8 0%, transparent 70%)",
					mixBlendMode: "multiply",
					filter: "blur(60px)",
				}}
			/>
			<div
				className="absolute top-1/4 -right-24 w-[500px] h-[500px] rounded-full opacity-25 pointer-events-none"
				style={{
					background: "radial-gradient(circle, #E84B6A 0%, transparent 70%)",
					mixBlendMode: "multiply",
					filter: "blur(80px)",
				}}
			/>
			<div
				className="absolute bottom-0 left-1/3 w-[400px] h-[400px] rounded-full opacity-20 pointer-events-none"
				style={{
					background: "radial-gradient(circle, #3ED8C3 0%, transparent 70%)",
					mixBlendMode: "multiply",
					filter: "blur(70px)",
				}}
			/>
			<div
				className="absolute top-1/2 left-1/4 w-[350px] h-[350px] rounded-full opacity-15 pointer-events-none"
				style={{
					background: "radial-gradient(circle, #A855F7 0%, transparent 70%)",
					mixBlendMode: "multiply",
					filter: "blur(90px)",
				}}
			/>
		</div>
	);
}
